import { cn } from '@/shared/lib/cn'

export interface ActivationMarkProps {
  /** Se il modulo è attivo: banda a righe anziché linea piatta. */
  active: boolean
  /** `y` corre in verticale (rail, bordo scheda), `x` in orizzontale (sotto una tab). */
  orientation?: 'x' | 'y'
  /** Anima la comparsa della banda quando lo stato passa ad attivo. */
  animate?: boolean
  className?: string
}

/**
 * Il segno di attivazione.
 *
 * È l'unico segno di stato dei moduli in tutta l'applicazione. Compare come
 * indicatore della voce attiva nel rail, sul fianco delle schede modulo in
 * Impostazioni e accanto ai contenuti che un modulo produce. Un solo segno,
 * un solo significato: questa capacità è attiva.
 *
 * Decorativo per gli assistenti vocali — lo stato è già scritto nel testo
 * accanto, ripeterlo sarebbe rumore.
 */
export function ActivationMark({
  active,
  orientation = 'y',
  animate = false,
  className,
}: ActivationMarkProps) {
  return (
    <span
      aria-hidden="true"
      className={cn(
        'block shrink-0',
        orientation === 'y' ? 'w-[3px]' : 'h-[3px] w-full',
        active ? 'activation-mark' : 'activation-mark-idle',
        active && animate && 'animate-weave',
        className,
      )}
    />
  )
}
